import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import Dictionary from './Dictionary';
import Manage from './Manage'; // Will be created

const ADMIN_EMAILS = ['chernyshevsky@dict.com'];

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  /* Language State */
  const [lang, setLang] = useState(() => {
    const savedLang = localStorage.getItem('dictionary_lang');
    if (savedLang) return savedLang;

    // Detect browser language if no saved preference
    const browserLang = navigator.language.split('-')[0];
    return browserLang === 'tr' ? 'tr' : 'en';
  });

  useEffect(() => {
    localStorage.setItem('dictionary_lang', lang);
  }, [lang]);

  /* Theme State */
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('dictionary_theme');
    return savedTheme || 'yellow';
  });

  useEffect(() => {
    localStorage.setItem('dictionary_theme', theme);
  }, [theme]);

  // Auth State
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center font-black text-2xl">Loading...</div>;
  }



  const isAdmin = user && ADMIN_EMAILS.includes(user.email);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dictionary user={user} isAdmin={isAdmin} lang={lang} setLang={setLang} theme={theme} setTheme={setTheme} />} />
        <Route
          path="/manage"
          element={
            isAdmin ? <Manage user={user} lang={lang} /> : <Navigate to="/" replace />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;